import React, { useMemo } from "react";
import { Row, Col } from 'reactstrap';

import BulkNotificationSignSignerList from "../../../../bulk/notification/sign/signer_list";

import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";

const CorporateBulkNotificationSignForm = props => {
  const {
    currentUser,
    data: {
      customFields,
      documentTypes
    }
  } = props;

  const agreementStateOptions = [
    { value: 'active', label: 'Activo' },
    { value: 'expired', label: 'Inactivo' },
  ]

  const tableColumnsDefault = [
    {
      field: 'document.entity.agreement_config.client.name',
      header: I18n.t('activerecord.attributes.corporate/agreement.company_client_name'),
      body: (row) => row?.document?.entity?.agreement_config?.client?.name || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre de la empresa',
        inputType: 'text',
        filterrific: {
          search: 'search_by_company_client',
        },
      },
    },
    {
      field: 'document.entity.agreement_config.provider.name',
      header: I18n.t('activerecord.attributes.corporate/agreement.company_provider_name'),
      body: (row) => row?.document?.entity?.agreement_config?.provider?.name || I18n.t('no_entry'),
    },
    {
      field: 'email',
      header: I18n.t('activerecord.attributes.signer.email'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el email del firmante',
        inputType: 'text',
        filterrific: {
          search: 'search_by_email'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'email_'
        }
      },
    },
    {
      field: 'role',
      header: I18n.t('activerecord.attributes.signer.role'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el rol del firmante',
        inputType: 'text',
        filterrific: {
          search: 'search_by_role'
        }
      },
    },
    {
      field: 'document.entity.identifier',
      header: I18n.t("activerecord.attributes.corporate/agreement.identifier"),
      body: (row) => row?.document?.entity?.agreement_config?.identifier || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador del contrato',
        inputType: 'text',
        filterrific: {
          search: 'search_by_agreement_identifier'
        }
      },
    },
    {
      field: 'document.entity.active_to_s',
      header: 'Estado del Contrato',
      body: (row) => row?.document?.entity?.active_to_s || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Seleccione un estado de contratación',
        inputType: 'simple_select',
        options: agreementStateOptions,
        filterrific: {
          search: 'by_agreement_state'
        }
      },
    },
    {
      field: 'document.entity.start_date_to_s',
      header: I18n.t("activerecord.attributes.corporate/agreement.start_date"),
      body: (row) => row?.document?.entity?.start_date_to_s || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de inicio del contrato',
        inputType: 'text',
        filterrific: {
          search: 'search_by_agreement_start_date'
        }
      },
    },
    {
      field: 'document.entity.end_date_to_s',
      header: I18n.t("activerecord.attributes.corporate/agreement.end_date"),
      body: (row) => row?.document?.entity?.end_date_to_s || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de fin del contrato',
        inputType: 'text',
        filterrific: {
          search: 'search_by_agreement_end_date'
        }
      },
    },
    {
      field: 'document.label',
      header: I18n.t("activerecord.attributes.document.label"),
      body: (row) => row?.document?.label || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del documento',
        inputType: 'text',
        filterrific: {
          search: 'search_by_document_name'
        }
      },
    },
    {
      field: 'document_type.name',
      header: I18n.t("activerecord.attributes.document.document_type"),
      filter: {
        enabled: true,
        placeholder: 'Seleccione un tipo de documento',
        inputType: 'simple_select',
        options: _.map(documentTypes, type => ({
          value: type.id,
          label: type.name,
        })),
        filterrific: {
          search: 'by_document_type'
        }
      },
    },
    {
      field: 'created_at_to_s',
      header: `${I18n.t("activerecord.attributes.signer.created_at")}`,
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de solicitud',
        inputType: 'text',
        filterrific: {
          search: 'search_by_created_at'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'created_at_'
        }
      },
    },
  ]

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `document.entity.custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.document.entity.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: 'search_by_key_custom_fields',
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return (
    <Row>
      <Col md="12">
        <BulkNotificationSignSignerList
          dataTableConfiguration={{
            columns: tableColumns
          }}
          configuration={{
            showDistributionListFilter: false,
            context: 'corporate',
            defaultRequestParams: {"filterrific": { "by_aasm_state": "pending" }},
            formName: 'corporate_bulk_notification_sign',
          }}
          routes={{
            indexSignersPath: Routes.corporate_signers_path,
          }}
        />
      </Col>
    </Row>
  );
};

export default CorporateBulkNotificationSignForm;
